import React from 'react';
import { motion } from 'framer-motion';
import { Search, Shield, Target, Users, MessageCircle } from 'lucide-react';
export function WhatYouGet() {
  const benefits = [{
    icon: Search,
    title: 'Clarity up front',
    description: "You'll know exactly what the speaker will deliver"
  }, {
    icon: Shield,
    title: 'Safe delivery',
    description: 'No risks, surprises, or off-brand moments'
  }, {
    icon: Target,
    title: 'Strategic framing',
    description: 'Talks built around your challenges, not generic keynotes'
  }, {
    icon: Users,
    title: 'Audience shift',
    description: 'Engagement, insight and real behavioral change'
  }, {
    icon: MessageCircle,
    title: 'Debrief support',
    description: 'Optional follow-up insights for team leaders or L&D'
  }];
  return <section className="py-24 bg-cream-50" data-id="element-134">
      <div className="max-w-7xl mx-auto px-6" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-heading text-navy-900 mb-6" data-id="element-137">
            What You Get
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12" data-id="element-138">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all text-center border border-cream-100" data-id="element-139">
              <div className="w-12 h-12 mx-auto bg-cream-100 rounded-full flex items-center justify-center mb-4 text-gold-500" data-id="element-140">
                <benefit.icon size={24} data-id="element-141" />
              </div>
              <h3 className="text-lg font-bold text-navy-900 mb-2" data-id="element-142">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-143">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-144">
          <p className="text-navy-800 font-medium italic" data-id="element-145">
            Whether you're booking for 50 team leads or 2,000 delegates – this
            is thought leadership designed to create traction.
          </p>
        </div>
      </div>
    </section>;
}